export default "__VITE_ASSET__CU0ugjXO__"